import { isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { ParamServicesService } from 'src/app/services/param-services.service';

@Component({
  selector: 'app-chat-bot',
  templateUrl: './chat-bot.component.html',
  styleUrls: ['./chat-bot.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatBotComponent implements OnInit {
  @Input() logo = undefined;
  @Output() detectChangesEmitter = new EventEmitter();
  public showChat = false;
  public stylesChat = undefined;
  public openedChat = false;
  public closing = false;

  public actualRoute = undefined;
  private _headerSuscription = new Subscription();
  public dataChat = undefined;

  constructor(
    public paramSv: ParamServicesService,
    private _cdr: ChangeDetectorRef,
    private _elementRef: ElementRef,
    @Inject(PLATFORM_ID) private platformId: any
  ) {}

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }
    if (this.paramSv.activeChat) {
      console.log('this.paramSv.activeChat :>> ', this.paramSv.activeChat);
      this.showChat = this.paramSv.activeChat;
    }
    this.actualRoute = window.location.pathname;
    this.setStyleChat();
    this._headerSuscription = this.paramSv.emitImagesObs.subscribe(
      (item: any) => {
        if (item.name === 'chat') {
          this.setStyleChat();
        }
      }
    );
  }

  ngOnDestroy(): void {
    this._headerSuscription.unsubscribe();
  }

  setStyleChat() {
    this.showChat = this.paramSv.activeChat || false;
    const data = this.paramSv.chat;
    if (data) {
      this.dataChat = data;
      if (data.styleChat) {
        const stylesChat = data.styleChat;
        this.stylesChat = stylesChat;
      }
      this._elementRef.nativeElement.style.setProperty(
        '--color-bg-chat',
        this.stylesChat.textFloatingBg
      );
    }
    this.detectChangesEmitter.emit();
    this._cdr.detectChanges();
  }

  toggleChat() {
    if (this.closing) return;
    if (!this.openedChat) {
      this.openedChat = !this.openedChat;
      return true;
    }

    this.closing = true;
    setTimeout(() => {
      this.openedChat = false;
      this.closing = false;
      this._cdr.detectChanges();
    }, 500);
  }
}
